export default "/static/8dfd90528ba09cfa.svg"